import { cloneDeep } from 'lodash';
import ConstCode from '@/common/constants/ConstCode';
const mutations = {
  setName: (state, name) => {
    state.meta.name = name;
  },
  setHeader: (state, header = { userNo: 0, accessToken: '' }) => {
    state.header = header;
  },
  subscribe: (state, roomNo) => {
    state.selectedRoom.roomNo = roomNo;
  },
  unsubscribe: (state) => {
    state.selectedRoom.roomNo = '';
  },
  appendChat: (state, message = [] || {}) => {
    if (Array.isArray(message)) state.chats.data = [...state.chats.data, ...message];
    else state.chats.data = [...state.chats.data, message];
  },

  selectRoom: (state, room) => {
    state.selectedRoom = room;
  },
  shouldIMoveScroll: (state, scroll) => {
    state.shouldIMoveScroll = scroll;
  },
  resetSelected: (state) => {
    state.selectedRoom = {
      roomNo: '',
      orderNo: 0,
      user: []
    };
  },
  setSelectedRoomUser: (state, roomUser = []) => {
    state.selectedRoom.user = roomUser;
  },
  setSelectedRoom: (state, roomNo = '') => {
    state.selectedRoom.roomNo = roomNo;
  },
  setRoomPage: (state, page = 1) => {
    state.room.page = page;
  },
  setRoomPageNextId: (state, nextId) => {
    state.room.nextId = nextId;
  },
  setRoomTotalPage: (state, totalPage = 2) => {
    state.room.totalPage = totalPage;
  },
  setRoomLoading: (state, isLoading = false) => {
    state.room.isLoading = isLoading;
  },
  setRoomType: (state, roomType = null) => {
    state.room.roomType = roomType;
  },
  setRoomData: (state, data = []) => {
    state.room.data = mergeRooms(state.room.data, data);
  },
  flushRoomData: (state) => {
    state.room.data = [];
    state.room.page = 1;
    state.room.totalPage = 2;
    state.room.nextId = null;
    state.room.isLoading = false;
  },

  setChatData: (state, data = []) => {
    state.chats.data = [...data, ...state.chats.data];
  },
  setChatTotalPage: (state, totalPage = 2) => {
    state.chats.totalPage = totalPage;
  },
  setChatPage: (state, page = 1) => {
    state.chats.page = page;
  },
  flushChatData: (state) => {
    state.chats.data = [];
    state.chats.page = 1;
    state.chats.totalPage = 2;
  },
  purge: (state) => {
    state.header = {
      userNo: 0,
      accessToken: ''
    };
    state.selectedRoom = {
      roomNo: '',
      user: []
    };

    state.room = {
      page: 1,
      limit: 10,
      totalPage: 2,
      nextId: null,
      roomType: null,
      data: [],
      chatTab: null,
      isLoading: false
    };

    state.chats = {
      page: 1,
      limit: 10,
      totalPage: 2,
      data: []
    };
    state.shouldIMoveScroll = false;
  },
  readAllMessages: (state, userNo) => {
    const chatsCopy = [...state.chats.data];
    chatsCopy.forEach((v) => {
      if (v.userNo !== userNo && v.userNo === state.header.userNo) v.isRead = true;
      if (v.userNo !== userNo && userNo === state.header.userNo) v.isRead = true;
    });
    state.chats.data = chatsCopy;
  },

  leaveRoomAtRoom: (state, { roomNo } = {}) => {
    if (!roomNo || state.selectedRoom?.roomNo !== roomNo) return;

    state.selectedRoom = {
      roomNo: '',
      orderNo: 0,
      user: []
    };
  },
  leaveRoomAtLobby: (state, { roomNo } = {}) => {
    if (!roomNo) return;

    state.room.data = sortRoomsByLatestBubble(state.room.data.filter((room) => room.roomNo !== roomNo));
  },
  appendRoom: (state, room) => {
    const { roomType } = state.room;

    if (!shouldIncludeRoom(room, roomType)) return;

    state.room.data = sortRoomsByLatestBubble(upsertRoom(state.room.data, room));
  },

  setLobbyStoreChatState: (state, { storeNo, isStoreChattable, isRoomChattable } = {}) => {
    if (!storeNo) return;

    const data = [...state.room.data];
    state.room.data = data.map((room) => {
      if (room?.storeNo === storeNo && room.store) {
        room.store.isChattable = isStoreChattable;
        room.isChattable = isRoomChattable;
      }
      return room;
    });
  },
  setRoomStoreChatState: (state, { storeNo, isStoreChattable, isRoomChattable } = {}) => {
    if (!storeNo || state.selectedRoom?.store?.storeNo !== storeNo) return;

    const selected = cloneDeep(state.selectedRoom);
    selected.store.isChattable = isStoreChattable;
    selected.isChattable = isRoomChattable;
    state.selectedRoom = selected;
  },
  setLobbyOrderState: (state, { orderNo, orderState, duration = '', cancelReason = '' } = {}) => {
    if (!orderNo) return;

    const data = [...state.room.data];
    const idx = data.findIndex((room) => room.orderNo === orderNo);
    const picked = data[idx];
    if (!picked?.order) return;

    picked.order.orderState = orderState;
    durationCancelMapper(orderState, duration, cancelReason, picked);

    state.room.data = data;
  },
  setRoomOrderState: (state, { orderNo, orderState, duration = '', cancelReason = '' } = {}) => {
    if (!orderNo || state.selectedRoom?.orderNo !== orderNo || !state.selectedRoom?.order) return;

    const selected = cloneDeep(state.selectedRoom);
    selected.order.orderState = orderState;
    durationCancelMapper(orderState, duration, cancelReason, selected);

    state.selectedRoom = selected;
  },

  updateLastBubble: (state, { latestBubble, roomNo }) => {
    if (!latestBubble) return;

    const data = [...state.room.data];
    const selectedNo = roomNo;
    const idx = data.findIndex((room) => room.roomNo === selectedNo);
    const picked = data[idx];
    if (!picked) return;

    picked.lastBubble = latestBubble;
    state.room.data = sortRoomsByLatestBubble(data);
  },
  setRoomUnreadBubbleCount: (state, { roomNo, count }) => {
    const data = [...state.room.data];
    const selectedNo = roomNo;
    const idx = data.findIndex((room) => room.roomNo === selectedNo);
    const picked = data[idx];
    if (picked) {
      picked.unreadCount = count;
    }

    state.room.data = data;
  }
};

const mergeRooms = (currentRooms = [], incomingRooms = []) => {
  const merged = [...currentRooms];

  incomingRooms.forEach((room) => {
    const idx = merged.findIndex((currentRoom) => currentRoom.roomNo === room.roomNo);

    if (idx === -1) {
      merged.push(room);
      return;
    }

    merged[idx] = {
      ...merged[idx],
      ...room
    };
  });

  return merged;
};

const upsertRoom = (rooms = [], targetRoom) => {
  const copiedRooms = [...rooms];
  const idx = copiedRooms.findIndex((room) => room.roomNo === targetRoom.roomNo);

  if (idx === -1) {
    copiedRooms.push(targetRoom);
    return copiedRooms;
  }

  copiedRooms[idx] = {
    ...copiedRooms[idx],
    ...targetRoom
  };

  return copiedRooms;
};

const shouldIncludeRoom = (room, roomType) => {
  if (!room) return false;
  if (!roomType) return ['INQUIRY', 'ORDER'].includes(room.roomType);

  return room.roomType === roomType;
};

const sortRoomsByLatestBubble = (rooms = []) => {
  const fallbackTime = Date.now() - 1000 * 60 * 60 * 24 * 100;

  return [...rooms].sort((roomA, roomB) => {
    const roomBTime = roomB?.lastBubble?.regDate ? new Date(roomB.lastBubble.regDate).getTime() : fallbackTime;
    const roomATime = roomA?.lastBubble?.regDate ? new Date(roomA.lastBubble.regDate).getTime() : fallbackTime;

    return roomBTime - roomATime;
  });
};

const durationCancelMapper = (orderState, duration, cancelReason, picked) => {
  if (!picked?.order) return;

  const cookingDurationWhen = 'COOKING';
  const deliverDurationWhen = 'DELIVERY';
  const cancelWhen = 'ORDER_CANCELLED';

  switch (orderState) {
    case cookingDurationWhen:
      picked.order.cookingDuration = duration;
      break;
    case deliverDurationWhen:
      picked.order.deliveryDuration = duration;
      break;
    case cancelWhen:
      picked.order.cancelledReason = cancelReason;
      if (picked.store) picked.store.isChattable = false;
      picked.isChattable = false;
  }
};
export default { ...mutations };
